import { z } from 'zod';

/**
 * Mirrors the workflow's output schema in workspace-api. Declared here rather than imported: this
 * is a browser bundle and cannot reach into a service. The agent's evals score the same shape, so
 * a drift shows up there rather than as a silently empty form.
 */
const generatedTemplateSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  sections: z.array(
    z.object({
      name: z.string(),
      position: z.number(),
      required: z.boolean(),
      aiAllowed: z.boolean(),
      instructions: z.string().nullable(),
    }),
  ),
});

export type GeneratedTemplate = z.infer<typeof generatedTemplateSchema>;

/**
 * Validates the workflow's own output, which arrives already decoded on its stream node.
 *
 * Not the assistant text: the text on that message belongs to the sub-agents, whose schemas are a
 * different shape, so reading it would reject a run that succeeded.
 */
export function parseGeneratedTemplate(value: unknown): GeneratedTemplate | null {
  const parsed = generatedTemplateSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
